import React from 'react';
import PropTypes from 'prop-types';

export default class PageLayout extends React.PureComponent {
  renderContent() {
    const { children } = this.props;

    return <div className="page-layout-content">{children}</div>;
  }

  render() {
    const { className, hero, subfooter } = this.props;

    return (
      <div className={className}>
        {hero}
        {this.renderContent()}
        {subfooter}
      </div>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  hero: PropTypes.element,
  subfooter: PropTypes.element,
};

PageLayout.defaultProps = {
  className: '',
  hero: null,
  subfooter: null,
};
